import window from './window';
import { AVAILABLE_REDIRECTS } from './constants';
import { redirectHandler as collegeProfileRedirectHandler, matchRegex as collegeProfileMatchRegex, } from './equivalent-page-college-profile';
export const SUPPORTED_REDIRECTS = {
    [AVAILABLE_REDIRECTS.COLLEGE_PROFILE]: collegeProfileRedirectHandler,
};
export const getEquivalenPageName = () => {
    const path = window.location.pathname;
    if (collegeProfileMatchRegex.test(path)) {
        return AVAILABLE_REDIRECTS.COLLEGE_PROFILE;
    }
    return null;
};
